import React,{Component  } from "react";
import {NavLink} from 'react-router-dom';
import axios from 'axios';
import { API_ROOT } from './../api-config';
import './../assets/css/loginform.css';
class Processcreate extends Component{

    constructor(props)
    {
        super(props);
        this.state={types:[],alreadyexits:null};
    }
    componentDidMount() {
        this.gettypes();
        }
    handlechange=(e)=>{

        if (e.target.id === 'processname') {
            this.setState({[e.target.id]: e.target.value});
            } else if(e.target.id === 'model') {
                this.setState({[e.target.id]: e.target.value});
                }

    }
    gettypes()
    {
        axios.get(API_ROOT+"/gettype").then(result=>{
            let populatedtypesvalues = result.data['msg'].map(result => { return {id: result.id, type_name: result.model_name} })
            this.setState({ types: populatedtypesvalues });
        })

    }

    handlesubmit=(e)=>{
        e.preventDefault();
        axios.post(API_ROOT+'/checkprocess',this.state).then(result=>{
            if(result.data['msg'].length >=1)
            {
                this.setState({'alreadyexits':'Process is already Exists'});
            } else {
        axios.post(API_ROOT+'/postprocess',this.state).then(result=>{
        this.props.history.push('/admin/processlist');
        })
    } })
        
            }


    render()
    {

        return(
<div className="content">
    
<form onSubmit={this.handlesubmit} method="post">
<div style={{"border":"1px solid #e5e5e5"}} className="card">
  <div style={{"margin":"7px"}} className="card-body">

      <div className="row">

<div className="col-md-6">
<div className="form-group">
    <label for="exampleInputEmail1">Model</label>
    <select required className="form-control" onChange={this.handlechange} id="model" >
        <option value="">Select Model</option>
        {this.state.types.map((cattypes) => <option key={cattypes.id} value={cattypes.id}>{cattypes.type_name}</option>)}
    </select>
  </div>
  </div>



<div className="col-md-6">
<div className="form-group">
    <label for="exampleInputEmail1">Process name</label>
    <input pattern=".{2,70}" title="2 to 70 Characters" type="text" required placeholder="Enter process name" className="form-control" onChange={this.handlechange} id="processname" />
  </div>
  </div>





</div>

<div className="row">
<div style={{"textAlign":"right"}} className="col-md-12">
<span style={{"color":"red"}}>{this.state.alreadyexits} </span>&nbsp;&nbsp;
<NavLink
                      to="/admin/processlist"
                      className="nav-link"
                      activeClassName="active"
                    >
<button type="button" className="btn btn-primary">Back</button>
                    </NavLink>&nbsp;<button type="submit" className="btn btn-primary">Submit</button>
  </div>
  </div>

          </div>
          </div>
          </form>
          </div>
)
    }

}

export default Processcreate;